import React, { useState } from 'react';
import './QAManagement.css';

/**
 * 🎯 Q&A MANAGEMENT COMPONENT 2025
 * 
 * Toggle-Sektion für Q&A Widget nach Design-Guide:
 * - 1:1 Text-Edit-Design
 * - Dynamische Q&A Items kompakt zusammengefasst
 * - Frage/Antwort-Paare Management
 * - Add/Remove-Funktionalität
 * - Spezifische Klassennamen
 */
function QAManagement({
    qaItems,
    addQAItem,
    removeQAItem,
    updateQAItem,
    editData
}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="qa-management">
            {/* Toggle Header */}
            <div 
                className={`qa-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <div className="qa-header-content">
                    <div className="qa-header-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <circle cx="8" cy="6" r="2" stroke="currentColor" strokeWidth="1.5"/>
                            <path d="M8 10v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            <circle cx="8" cy="13" r="0.5" fill="currentColor"/>
                        </svg>
                    </div>
                    <h3 className="qa-header-title">Q&A Items</h3>
                    <div className="qa-counter">
                        {qaItems?.length || 0}
                    </div>
                </div>
                <div className={`qa-toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content */}
            {isExpanded && (
                <div className="qa-content">
                    {/* Add Button */}
                    <div className="add-qa-section">
                        <button
                            onClick={addQAItem}
                            className="add-qa-btn"
                        >
                            <div className="btn-icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M7 3V11M3 7H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <span>Add New Q&A</span>
                        </button>
                        <div className="add-qa-hint">
                            Create helpful Q&A pairs to address common customer questions
                        </div>
                    </div>

                    {/* Q&A Items Grid */}
                    {qaItems && qaItems.length > 0 && (
                        <div className="qa-grid">
                            {qaItems.map((item, index) => (
                                <div key={item.id || index} className="qa-edit-card">
                                    {/* Card Header */}
                                    <div className="qa-card-header">
                                        <div className="qa-card-title">
                                            <div className="qa-card-number">{index + 1}</div>
                                            <span>Q&A</span>
                                        </div>
                                        <button
                                            onClick={() => removeQAItem(index)}
                                            className="qa-remove-btn"
                                            title="Remove Q&A"
                                        >
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                            </svg>
                                        </button>
                                    </div>

                                    {/* Question Field */}
                                    <div className="qa-content-section">
                                        <label className="qa-field-label">Question</label>
                                        <textarea
                                            value={item.question || ''}
                                            onChange={(e) => updateQAItem(index, 'question', e.target.value)}
                                            placeholder="Enter your question..."
                                            className="qa-textarea"
                                            rows={2}
                                        />
                                    </div>

                                    {/* Answer Field */}
                                    <div className="qa-content-section">
                                        <label className="qa-field-label">Answer</label>
                                        <textarea
                                            value={item.answer || ''}
                                            onChange={(e) => updateQAItem(index, 'answer', e.target.value)}
                                            placeholder="Enter your answer..."
                                            className="qa-textarea"
                                            rows={4}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Empty State */}
                    {(!qaItems || qaItems.length === 0) && (
                        <div className="qa-empty-state">
                            <div className="qa-empty-state-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" strokeDasharray="3 3" opacity="0.3"/>
                                    <circle cx="24" cy="18" r="3" stroke="currentColor" strokeWidth="1.5" opacity="0.5"/>
                                    <path d="M24 26v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
                                    <circle cx="24" cy="32" r="1" fill="currentColor" opacity="0.5"/>
                                </svg>
                            </div>
                            <h4>No Q&A Items Yet</h4>
                            <p>Click "Add New Q&A" to create your first question and answer pair</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default QAManagement;
